import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { updateProcessingStageStep, updateJobServiceTransition } from "requesters/jobServiceRequester";
import { getBaseUrl, getCurrentRole } from "../../../../../reducers";
import CommentBox from "../CommentBox";
import ConfirmationModal from "../../../modals/ConfirmationModal";
import CheckingStep from "./CheckingStep";
import FlagJobServiceModal from "../../../modals/FlagJobServiceModal";
import { ADMIN } from "../../../../../../../utils/constants";

const Unprocessed = ({
  jobService, reloadData, comment, setComment, forAdditionalWork
}) => {
  const {
    attributes: {
      completedStepsForUnprocessedOptions,
      jobNo,
      projectXJobNo,
      forProjectX,
      jobTitle
    }, id
  } = jobService
  const baseUrl = useSelector(getBaseUrl);
  const currentRole = useSelector(getCurrentRole)
  const isAdmin = currentRole.includes(ADMIN)
  const [checkingSteps, setCheckingSteps] = useState(completedStepsForUnprocessedOptions)
  const [requesting, setRequesting] = useState(false)
  const [targetStep, setTargetStep] = useState(null)
  const [showTransitionConfirmation, setShowTransitionConfirmation] = useState(false)
  const [showAddFlagModal, setShowAddFlagModal] = useState(false)

  const onClickStep = useCallback(step => {
    setRequesting(true)
    setTargetStep(step)
    // eslint-disable-next-line
    const newCheckingSteps = checkingSteps.map(s => s.value === step.value ? { ...s, checked: !s.checked } : s)
    setCheckingSteps(newCheckingSteps)
    updateProcessingStageStep(baseUrl, id, step.value, !step.checked)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        setRequesting(false)
        setTargetStep(null)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }, [baseUrl, id, reloadData])

  const sendToProcessingNavvis = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, "move-to-processing-navvis", comment)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        setRequesting(false)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  useEffect(() => {
    setCheckingSteps(completedStepsForUnprocessedOptions)
  }, [completedStepsForUnprocessedOptions])

  const generateCheckingSteps = useMemo(() => (
    checkingSteps.map((step, idx) => (
      <CheckingStep
        key={step.value}
        step={step}
        idx={idx}
        onClickStep={onClickStep}
        requesting={requesting}
        targetStep={targetStep} />
    ))
  ), [checkingSteps])

  const AddFlagSection = () => {
    return (
      <div className="text-right">
        <button className="btn" type="button" onClick={() => setShowAddFlagModal(true)}>
          <i className="bi bi-flag-fill mr-2"></i>
          Add Flag
        </button>
        <FlagJobServiceModal
          show={showAddFlagModal}
          onHide={() => setShowAddFlagModal(false)}
          jobService={jobService}
          reloadData={reloadData} />
      </div>
    )
  }

  const allStepsCompleted = checkingSteps.every(step => step.checked)
  const displayJobNo = forProjectX ? projectXJobNo : jobNo

  return (
    <div className="unprocessed-section">
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="row justify-content-end align-baseline px-4">
            { !forAdditionalWork && AddFlagSection() }
          </div>
          <div className=" p-4">
            {generateCheckingSteps}
          </div>
        </div>
      </div>
      { !forAdditionalWork && (
        <div className="transition-comment">
          <CommentBox comment={comment} setComment={setComment} />
          <div className="row mt-4">
            <div className="mr-4 pt-2">Send to</div>
            <div className="mr-2">
              <button
                className={`btn ${(allStepsCompleted || isAdmin) ? "btn-outline-primary" : "btn-outline-secondary"}`}
                type="button"
                disabled={(!isAdmin && !allStepsCompleted) || requesting}
                onClick={() => setShowTransitionConfirmation(true)}>
                Processing
              </button>
              <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={showTransitionConfirmation} resetState={() => setShowTransitionConfirmation(false)} sendTo={sendToProcessingNavvis} messageType="Processing"></ConfirmationModal>
            </div>
          </div>
        </div>
      )}
    </div>
  )
};

export default Unprocessed;